module.exports = __webpack_public_path__ + "img/composer-level3.2b850f39.png";